/**
 * Ports of the local Firebase emulator suite.
 *
 * The browser (app.config.ts), the e2e seeding fixtures and firebase/emulators.json
 * must all agree on these. They are declared once here and imported by the app; the
 * e2e side reads the same values from e2e/support/emulators.ts, which is asserted
 * against this file by a unit test so the two cannot drift.
 */
export const EMULATOR_HOST = '127.0.0.1';

/**
 * A dedicated range, deliberately not the Firebase defaults (9099/8080/5001/9199).
 * A dev emulator suite is commonly already running from ParkinglessFunctions on the
 * default ports; the e2e suite has to be startable alongside it without either
 * having to be shut down, and without a test ever reading a dev emulator's data.
 */
export const EMULATOR_PORTS = {
  auth: 9399,
  firestore: 8380,
  functions: 5301,
  storage: 9499,
} as const;
